import { render, staticRenderFns } from "./accessRecord.vue?vue&type=template&id=2650cc4a&scoped=true&"
import script from "./accessRecord.vue?vue&type=script&lang=js&"
export * from "./accessRecord.vue?vue&type=script&lang=js&"
import style0 from "./accessRecord.vue?vue&type=style&index=0&id=2650cc4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2650cc4a",
  null
  
)

export default component.exports